export const holidays = [
  { date: '2025-01-01', name: "New Year's Day" },
  { date: '2025-02-09', name: 'Super Bowl LIX' },
  { date: '2025-03-17', name: "St Patrick's Day" },
  { date: '2025-05-26', name: 'Memorial Day' },
  { date: '2025-07-04', name: 'Independence Day' },
  { date: '2025-09-01', name: 'Labor Day' },
  { date: '2025-10-31', name: 'Halloween' },
  { date: '2025-11-27', name: 'Thanksgiving Day' },
  { date: '2025-12-25', name: 'Christmas Day' },
  { date: '2025-02-16', name: "Presidents' Day" },
  { date: '2025-04-20', name: 'Easter Sunday' },
  { date: '2025-05-05', name: 'Cinco de Mayo' },
  { date: '2025-09-07', name: 'Labor Day Observed' },
  { date: '2025-10-13', name: 'Columbus Day' },
  { date: '2025-11-11', name: 'Veterans Day' },
  { date: '2025-11-28', name: 'Thanksgiving Weekend' }
];
